<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BlujayBcaTransaction1Index",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  